<template>
  <b-button
    class="button_clear_filter"
    type="is-text"
    :size="size"
    @click="$emit('click', $event)"
  >
    clear
  </b-button>
</template>

<script>
export default {
  name: "FilterButtonClear",
  props: {
    size: {
      type: String,
      default: 'is-small'
    },
  }
}
</script>

<style lang="scss" scoped>
.button_clear_filter {
  margin-right: 10px;
  margin-left: -10px;
}
</style>
